import React, { useEffect } from "react";
import * as s from "./Clients.styles";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../store/actions/index";

// shared
import Spinner from "../../../components/shared/spinner/Spinner";

// components
import ClientsComponent from "../../../components/admin/clients/ClientsComponent";

const Clients = () => {
  const dispatch = useDispatch();

  const clientsLoading = useSelector((state) => state.forClients.loading);
  useEffect(() => {
    dispatch(actions.fetchUsers(1, 10));
  }, []);

  return (
    <s.Container>
      {clientsLoading === false ? (
        <s.ClientsContainer>
          <ClientsComponent showCreateClient={true} />
        </s.ClientsContainer>
      ) : (
        <s.SpinnerContainer>
          <Spinner />
        </s.SpinnerContainer>
      )}
    </s.Container>
  );
};

export default Clients;
